var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.868,
    height: 21.081,
    viewBox: "0 0 20.868 21.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9562",
    "data-name": "Group 9562",
    transform: "translate(437.18 22767)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 6.25,
    cy: 6.25,
    r: 6.25,
    transform: "translate(-435.18 -22765)",
    fill: "none",
    stroke: "#E62E2E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3689",
    "data-name": "Line 3689",
    x1: 5.36,
    y1: 5.36,
    transform: "translate(-424.5 -22754.107)",
    fill: "none",
    stroke: "#E62E2E",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconRed);
export default __webpack_public_path__ + "static/media/SearchIconRed.62ee5719280f7ab33d150607592d98d8.svg";
export { ForwardRef as ReactComponent };